// extracted by mini-css-extract-plugin
export default {"email-input":"EmailInput_email-input__JMLUz","error":"EmailInput_error__C+SFb"};